import { Form, FormGroup } from "@angular/forms";
import { ValidateUtils } from "./ValidateUtils";

export class MessageUtils {

  constructor(){}

public static TXT_ACCESS_CONDITIONS:string = "Este es un sistema de información de la Comunidad de Madrid y su uso está restringido a personas autorizadas, en adelante 'usuarios'. En consecuencia, no está permitido suprimir, eludir o manipular los dispositivos técnicos de protección, las huellas digitales o cualesquiera mecanismos de información y/o identificación y acceso al sistema.\n\nEl usuario se obliga a utilizar este sistema de información de forma diligente, correcta, lícita y de conformidad a la Ley y al presente aviso. En particular, se compromete a no utilizar los contenidos con una finalidad contraria a la Ley, moral u orden público; a no reproducir o copiar, no distribuir y no permitir el acceso público, a excepción de que cuente con autorización expresa, y en cualquier tipo de soporte, ya sea físico o lógico.\n\nEl usuario se compromete a hacer un uso diligente y a mantener en secreto la contraseña o los mecanismos de autenticación proporcionados para acceder a este sistema. En consecuencia, los usuarios son responsables de la adecuada custodia y confidencialidad de cualesquiera identificadores y/o contraseñas que le sean suministradas, y se comprometen a no ceder su uso a terceros, ya sea temporal o permanente, ni a permitir su acceso a personas ajenas. Será responsabilidad del usuario la utilización ilícita de los servicios por cualquier tercero ilegítimo que emplee a tal efecto una contraseña a causa de una utilización no diligente o de la pérdida de la misma por el usuario. En virtud de lo anterior, es obligación del usuario notificar de forma inmediata a los gestores del sistema acerca de cualquier hecho que permita el uso indebido de los identificadores y/o contraseñas, tales como el robo, extravío, o el acceso no autorizado a los mismos, con el fin de proceder a su inmediata cancelación.";
public static TITLE_ACCESS_CONDITIONS:string = `Este es un sistema de información de la Comunidad de Madrid y su uso está restringido a personas autorizadas, en adelante 'usuarios'. En consecuencia, no está permitido suprimir, eludir o manipular los dispositivos técnicos de protección, las huellas digitales o cualesquiera mecanismos de información y/o identificación y acceso al sistema.

El usuario se obliga a utilizar este sistema de información de forma diligente, correcta, lícita y de conformidad a la Ley y al presente aviso. En particular, se compromete a no utilizar los contenidos con una finalidad contraria a la Ley, moral u orden público; a no reproducir o copiar, no distribuir y no permitir el acceso público, a excepción de que cuente con autorización expresa, y en cualquier tipo de soporte, ya sea físico o lógico.

El usuario se compromete a hacer un uso diligente y a mantener en secreto la contraseña o los mecanismos de autenticación proporcionados para acceder a este sistema. En consecuencia, los usuarios son responsables de la adecuada custodia y confidencialidad de cualesquiera identificadores y/o contraseñas que le sean suministradas, y se comprometen a no ceder su uso a terceros, ya sea temporal o permanente, ni a permitir su acceso a personas ajenas. Será responsabilidad del usuario la utilización ilícita de los servicios por cualquier tercero ilegítimo que emplee a tal efecto una contraseña a causa de una utilización no diligente o de la pérdida de la misma por el usuario. En virtud de lo anterior, es obligación del usuario notificar de forma inmediata a los gestores del sistema acerca de cualquier hecho que permita el uso indebido de los identificadores y/o contraseñas, tales como el robo, extravío, o el acceso no autorizado a los mismos, con el fin de proceder a su inmediata cancelación.`;

public static TITLE_INFO:string =  "Información";
public static TEXT_INFO_CORREO_INSTITUCIONAL:string = "El correo de acceso debe ser un correo institucional facilitado por tu centro o universidad como identificador en sus sistemas.";
public static TEXT_INFO_CODIGO_POSTAL:string = "El Código postal debe ser el de la vivienda habitual durante el curso académico. Para no residentes en España, introducir como Código Postal el número 99999";

public static TEXT_PRIVACY:string = `
<strong>Información sobre Protección de Datos</strong>
<br>
<u><strong>Responsable del tratamiento de sus datos</strong></u>
<strong>Responsable:</strong> Comunidad de Madrid
<strong>Domicilio social:</strong> <a href="https://www.comunidad.madrid/centros target="_blank" >www.comunidad.madrid/centros</a>
<strong>Contacto Delegado de Protección de Datos:</strong> protecciondatos.educacion@madrid.org
<br>
<u><strong>¿En qué actividad de tratamiento están incluidos mis datos personales y con qué fines se tratarán?</strong></u>
Carnet Universitario cuya finalidad es la creación de comunidad universitaria.
<br>
<u><strong>¿Cuál es la legitimación en la cual se basa la licitud del tratamiento?</u></strong>
RGPD 6.1 a) el interesado dio su consentimiento para el tratamiento de sus datos personales para uno o varios fines específicos.
<br>
<u><strong>¿Cómo ejercer sus derechos? ¿Cuáles son sus derechos cuando nos facilita sus datos?</u></strong>
Puede ejercitar, si lo desea, los derechos de acceso, rectificación y supresión de datos, así como solicitar que se limite el tratamiento de sus datos personales, oponerse al mismo, solicitar en su caso la portabilidad de sus datos, así como a no ser objeto de una decisión individual basada únicamente en el tratamiento automatizado, incluida la elaboración de perfiles.
<br>
Según la Ley 39/2015, el RGPD (UE) y la Ley Orgánica 3/2018, puede ejercitar sus derechos por Registro Electrónico o Registro Presencial, en ambos casos haciendo constar la referencia “Ejercicio de derechos de protección de datos”.
<br>
<u><strong>Tratamientos que incluyen decisiones automatizadas, incluida la elaboración de perfiles, con efectos jurídicos o relevantes.</u></strong>
No se realizan.
<br>
<u><strong>¿Por cuánto tiempo conservaremos sus datos personales?</u></strong>
Los datos personales proporcionados se conservarán por el siguiente periodo: Indeterminado
<br>
Los datos se mantendrán durante el tiempo que es necesario para cumplir con la finalidad para la que se recabaron y para determinar las posibles responsabilidades que se pudieran derivar de dicha finalidad y del tratamiento de los datos.
<br>
<u><strong>¿A qué destinatarios se facilitarán sus datos?</u></strong>
La Fundación para el conocimiento Madri+d, con domicilio en c/ Maestro Ángel Llorca 6, 3ª planta 28003 Madrid y NIF G83351346, tendrá acceso a los datos como entidad encargada de la gestión del carné universitario digital.
<br>
Puede consultar su política de privacidad en <a href="https://www.madrimasd.org/politica-privacidad" target="_blank">https://www.madrimasd.org/politica-privacidad.</a>
<br>
Se ofrecerá de manera agregada información derivada de análisis estadísticos realizados a partir de los datos obtenidos a todos los municipios y organismos públicos de la región para los que fuera de interés, con el fin de que puedan implementar políticas orientadas a este colectivo.
<br>
<u><strong>Derecho a retirar el consentimiento prestado para el tratamiento en cualquier momento.</u></strong>
Cuando el tratamiento esté basado en el consentimiento explícito, tiene derecho a retirar el consentimiento en cualquier momento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada.
<br>
<u><strong>Derecho a presentar una reclamación ante la Autoridad de Control.</u></strong>
Tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos <a href="http://www.aepd.es" target="_blank">http://www.aepd.es</a> si no está conforme con el tratamiento que se hace de sus datos personales.
<br>
<u><strong>Categoría de datos objeto de tratamiento.</u></strong>
Nombre y apellidos, DNI/NIE/Pasaporte., Código Postal del domicilio, teléfono, nacionalidad, fecha de nacimiento, género, correo electrónico personal e institucional, institución, titulación, intereses.
<br>
<u><strong>Información adicional.</u></strong>
Pueden consultar la información adicional y detallada de la información y de la normativa aplicable en materia de protección de datos en la web de la Agencia Española de Protección de Datos <a href="http://www.aepd.es" target="_blank>http://www.aepd.es</a>, así como la información sobre el Registro de Actividades de Tratamiento del Responsable antes señalado en el siguiente enlace: <a href="www.comunidad.madrid/protecciondedatos" target="_blank">www.comunidad.madrid/protecciondedatos</a>
 `;

public static TEXT_GENERIC_ERROR:string = 'Ha ocurrido un error, por favor, inténtelo más tarde.';

public static TEXT_CONFIRM_EMAIL:string = 'Se ha confirmado el alta de usuario correctamente. A continuación recibirás en tu correo institucional el fichero con el Carnet Universitario Digital. Si lo deseas, puedes acceder a consultar y/o modificar tu perfil desde esta misma página introduciendo los datos con los que te diste de alta.';

public static TEXT_CONFIRM_BAJA:string = 'El usuario se ha dado de baja correctamente.';
public static TEXT_BAJA:string = 'El usuario está dado de baja.';
public static TEXT_ALTA:string = 'El usuario ya está dado de alta.';



public static LINK_NOT_AVAILABLE:string = 'El link al que se está accediento ya no está disponible.';
public static PKPASS_INVALID:string = 'No se ha podido descargar el Carnet Universitario.';



public static TEXT_BUTTON_DARSEDEALTA:string = 'Darse de alta';
public static TEXT_BUTTON_GUARDAR:string = 'Guardar';

//----------------- SESSIONS -------------------

/**
 * Datos del usuario para el formulario.
 */
public static DATA_USER:string = 'dataUser';

/**
 * Boolean para ver si el email se ha confirmado.
 */
public static CONFIRM_ACCESS:string = 'confirmAccess';

/**
 * Boolean para indicar si se dio la baja en el formulario.
 */
public static CONFIRM_BAJA:string = 'confirmBaja';

/**
 * Boolean para indicar si el link está disponible.
 */
public static LINK_AVAILABLE:string = 'linkAvailable';

//----------------- FIN SESSIONS -------------------

/**
   * Devuelve un error custom en un campo del formulario.
   * @param campo Campo al que pintar el error.
   * cdMailPersonal, cdNifNie.
   * Importante: Mantener mismos nombres que en la base de datos.
   * @returns String del error.
   */
 public static getFormCustomErrorMessage(campo, form: FormGroup) {
  switch (campo) {
    case "cdMailPersonal":
      if (form.controls.cdMailPersonal.value.length > 150) {
        return "El correo electrónico es demasiado largo.";
      }

      if (ValidateUtils.validateErrorEmail(form, campo)) {
        return "El correo electrónico no es válido.";
      }
      if (ValidateUtils.validateErrorRequired(form, campo)) {
        return "Es obligatorio el correo electrónico institucional.";
      }
      break;
    case "cdMailUniversidad":
      if (ValidateUtils.validateErrorRequired(form, campo)) {
        return "Es obligatorio el correo electrónico institucional."
      }

      if (form.controls.cdMailUniversidad.value.length > 150) {
        return "El correo electrónico es demasiado largo.";
      }

      if (form.controls.cdMailUniversidad != null && form.controls.cdMailUniversidad.status == "INVALID") {
        return "El correo electrónico no es válido.";
      }



      break;
    case "cdNifNie":
      if (form.controls.cdNifNie != null && ValidateUtils.validateErrorRequired(form, campo)) {
        return "Es obligatorio el NIF/Pasaporte."
      }

      if (!form.controls.cdNifNie.valid) {
        return "EL NIF/Pasaporte no es válido.";
      }
      break;
    case "cdCodigoPostal":
      if (form.controls.cdCodigoPostal != null && ValidateUtils.validateErrorRequired(form, campo)) { return "El código postal es obligatorio."}
      if (!form.controls.cdCodigoPostal.valid) {return "El código postal no es válido."}
  }
}



}